import { Controller } from "react-hook-form";
import CustomButton from "../ui/CustomButton/CustomButton";
import { CustomText } from "../ui/CustomText/CustomText";
import { CustomPinInput } from "../ui/CustomPin/CustomPin";
import { otpValidator } from "./otpErrorUtils";

export function OtpAuthorizeStep({
  control,
  handleSubmit,
  otpValue,
  otpRecipient,
  onSubmit,
  isAuthorizing = false,
  onResend,
  resendSecondsLeft = 0,
  isResendCooldownActive = false,
  submitLabel,
}) {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-1">
        <h3 className="text-base font-semibold text-gray-900">
          Enter Authorization Code
        </h3>
        <p className="text-sm text-gray-500">
          A 6-digit code has been sent to{" "}
          <span className="font-medium text-gray-700">
            {otpRecipient ?? "your registered phone number"}
          </span>
        </p>
      </div>

      <Controller
        name="otp"
        control={control}
        rules={{ validate: (v) => otpValidator(v) ?? true }}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-2">
            <CustomPinInput
              length={6}
              type="number"
              oneTimeCode
              justify="center"
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              disabled={isAuthorizing}
            />
            {fieldState.error && (
              <CustomText c="error" size="sm" align="center">
                {fieldState.error.message}
              </CustomText>
            )}
          </div>
        )}
      />

      <div className="text-center">
        {isResendCooldownActive ? (
          <CustomText size="sm" c="dimmed">
            Code expires in{" "}
            <span className="font-medium text-primary-600">
              {String(Math.floor(resendSecondsLeft / 60)).padStart(2, "0")}:
              {String(resendSecondsLeft % 60).padStart(2, "0")}
            </span>
          </CustomText>
        ) : (
          <CustomText size="sm" c="dimmed">
            Didn&apos;t receive the code?{" "}
            <button
              type="button"
              onClick={onResend}
              disabled={isAuthorizing}
              className="text-primary-600 disabled:opacity-50 disabled:cursor-not-allowed hover:underline transition-colors"
            >
              Resend Code
            </button>
          </CustomText>
        )}
      </div>

      <div className="flex justify-center">
        <CustomButton
          color="primary"
          radius="md"
          loading={isAuthorizing}
          disabled={otpValue.length < 6 || isAuthorizing}
          onClick={handleSubmit(onSubmit)}
        >
          {submitLabel}
        </CustomButton>
      </div>
    </div>
  );
}
